import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import { theme } from './theme';

import Home from './pages/Home';
import GeneralResults from './pages/GeneralResults';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Rules from './pages/Rules';
import Decisions from './pages/Decisions';
import Theses from './pages/Theses';
import Publications from './pages/Publications';
import Agenda from './pages/Agenda';
import NotFound from './pages/NotFound';
import reportWebVitals from './reportWebVitals';
import { GlobalStyle } from './theme/styles';
import Theme from './theme';
import ReactGA from 'react-ga4';
import { usePageTrack } from './hooks/useAnalyticsPageTracker';
import LDA from './pages/LDA';
import LDAResult from './pages/LDAResult';
import LDAResultV2 from './pages/LDAResult/index_v2';
import LDAResultV3 from './pages/LDAResult/index_v3';

const TRACKING_ID = "G-B5MVPY6LNB"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const PageTrack = () => {
  //console.log('Run test')
  usePageTrack();

  return (<></>)
}

root.render(
  <React.StrictMode>
    <GlobalStyle />
    <Theme>
      <BrowserRouter>
        <PageTrack/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pesquisa" element={<GeneralResults />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/destaques" element={<Blog />} />
          <Route path='/destaques/:id' element={<BlogPost />} />
          <Route path="/normas-juridicas/" element={<Rules />} />
          <Route path="/normas-juridicas/:rule" element={<Rules />} />
          <Route path="/decisoes-judiciais/" element={<Decisions />} />
          <Route path="/decisoes-judiciais/:decision" element={<Decisions />} />
          <Route path="/teses-dissertacoes/" element={<Theses />} />
          <Route path="/teses-dissertacoes/:these" element={<Theses />} />
          <Route path="/publicacoes-selecionadas/" element={<Publications />} />
          <Route path="/publicacoes-selecionadas/:publication" element={<Publications />} />
          <Route path="/agenda/" element={<Agenda />} />
          <Route path="/agenda/:year" element={<Agenda />} />
          <Route path="/lda/" element={<LDA />} />
          <Route path="/lda/result" element={<LDAResultV2 />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent
          location="bottom"
          buttonText="Aceitar"
          declineButtonText="Recusar"
          cookieName="onda-cookies"
          style={{ background: theme.colors.gray.light }}
          buttonStyle={{ backgroundColor: theme.colors.green.light, color: '#fff', fontSize: "12pt" }}
          declineButtonStyle={{ 
            //color: "#4e503b", 
            color: theme.colors.black.dark,
            backgroundColor: theme.colors.gray.dark,
            fontSize: "12pt" }}
          enableDeclineButton={true}
          expires={150}
          contentStyle={{color: theme.colors.black.dark, fontSize: "12pt"}}
        >
          Usamos cookies em nosso site para oferecer a você a experiência mais completa, lembrando suas preferências e visitas repetidas. Ao clicar em “Aceitar”, você concorda com o uso de TODOS os cookies. 
          <br></br>
          No entanto, você pode recusar as configurações de cookies.
          {/* No entanto, você pode visitar "Configurações de cookies" para fornecer um consentimento controlado. */}
        </CookieConsent>
      </BrowserRouter>
    </Theme>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
